import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { useLang } from "../i18n";
import { RevealText } from "./Reveal";

export default function Testimonios() {
  const { t } = useLang();
  const tt = t.testimonios;

  return (
    <section id="opiniones" className="relative py-24 md:py-32 bg-surface grain">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex items-center gap-3 mb-8">
          <span className="h-px w-10 bg-brand-orange" />
          <span className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-brand-orange">{tt.overline}</span>
        </div>
        <RevealText
          as="h2"
          text={tt.title}
          className="font-display font-semibold tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl block max-w-3xl"
        />

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {tt.items.map((item, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-6%" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`testimonial-${i}`}
              className="relative bg-bg border border-border p-8 md:p-10 flex flex-col"
            >
              <Quote className="h-10 w-10 text-brand-orange/30 mb-4" />
              <div className="flex gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-brand-gold text-brand-gold" />
                ))}
              </div>
              <blockquote className="text-lg md:text-xl leading-relaxed text-white font-light">
                {`“${item.q}”`}
              </blockquote>
              <figcaption className="mt-8 pt-5 border-t border-border">
                <div className="font-display font-semibold text-lg">{item.n}</div>
                <div className="text-sm text-steel-400">{item.r}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
